import type { AiChatMessage } from './types';

import { useRef, useEffect } from 'react';

import Box from '@mui/material/Box';

import { Scrollbar } from 'src/components/scrollbar';

import { AiChatMessageItem } from './ai-chat-message-item';

// ----------------------------------------------------------------------

type Props = {
  messages: AiChatMessage[];
};

export function AiChatMessageList({ messages }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Scrollbar ref={scrollRef} sx={{ flex: '1 1 auto', p: 3 }}>
      <Box>
        {messages.map((message) => (
          <AiChatMessageItem key={message.id} message={message} />
        ))}
      </Box>
    </Scrollbar>
  );
}
